import { render, staticRenderFns } from "./PreHeader.vue?vue&type=template&id=24bdce2a&scoped=true&"
import script from "./PreHeader.vue?vue&type=script&lang=ts&"
export * from "./PreHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PreHeader.vue?vue&type=style&index=0&id=24bdce2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bdce2a",
  null
  
)

export default component.exports